import * as WebBrowser from 'expo-web-browser';
import i18n from '@/utils/i18n';
import React, { useMemo } from 'react';
import { Linking, Platform, StyleSheet, Text } from 'react-native';
import { OldWebLink } from './old-web-link';
import { partnerSupplier } from '@/utils/environment';
import { TYPOGRAPHY } from '@/styles';
import { useLayoutContext } from '@/contexts/layout-context';

export interface SupplierSignupTextProps {
  loginRequestEnabled: boolean;
  navigateToBecomeCustomer: () => void;
  navigateToLoginRecovery: () => void;
}

export const SupplierSignupText: React.FC<SupplierSignupTextProps> = ({
  loginRequestEnabled,
  navigateToBecomeCustomer,
  navigateToLoginRecovery,
}) => {
  const { isSmallLayout } = useLayoutContext();
  const contactLink = partnerSupplier.contactLink;
  const oldWebLink = partnerSupplier.oldWebLink;
  const renderOldWebLink = oldWebLink && Platform.OS === 'web' && isSmallLayout;

  // When loginRequestEnabled is true, show both links
  const becomeCustomerLinkComponent = loginRequestEnabled ? (
    <Text
      onPress={navigateToBecomeCustomer}
      style={[TYPOGRAPHY.medium, styles.link, styles.margin]}
    >
      {i18n.t('become_customer')}
    </Text>
  ) : null;

  const loginRecoveryLinkComponent = (
    <Text
      onPress={navigateToLoginRecovery}
      style={[TYPOGRAPHY.medium, styles.link]}
    >
      {i18n.t('having_trouble_logging_in')}
    </Text>
  );

  const isHardcodedContactLink = useMemo(
    () => Boolean(contactLink?.includes('form.jotform.com/222207234481044')),
    [contactLink],
  );

  const getLoginTroubleLinkComponent = () => {
    if (loginRequestEnabled && isHardcodedContactLink) {
      return loginRecoveryLinkComponent;
    }

    if (contactLink) {
      return (
        <Text
          onPress={() => {
            // open new tab on web, open in web view on mobile
            if (Platform.OS === 'web') {
              Linking.openURL(contactLink);
            } else {
              WebBrowser.openBrowserAsync(contactLink);
            }
          }}
          style={[TYPOGRAPHY.medium, styles.link]}
        >
          {i18n.t('having_trouble_logging_in')}
        </Text>
      );
    }

    return null;
  };

  const loginTroubleLinkComponent = getLoginTroubleLinkComponent();

  const oldWebLinkComponent =
    renderOldWebLink && oldWebLink ? (
      <OldWebLink
        style={[styles.link, contactLink ? styles.padding : null]}
        url={oldWebLink}
      />
    ) : null;

  return (
    <>
      {loginTroubleLinkComponent}
      {becomeCustomerLinkComponent}
      {oldWebLinkComponent}
    </>
  );
};

const styles = StyleSheet.create({
  link: {
    textAlign: 'center',
    textDecorationLine: 'underline',
  },
  margin: {
    marginTop: 24,
  },
  padding: {
    paddingTop: 16,
  },
});
